declare const fabiosouzaAjax: { ajaxurl: string; nonce: string } | undefined
declare const turnstile: { reset: () => void } | undefined

document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('contatoForm') as HTMLFormElement | null
  const feedback = document.getElementById('formFeedback')
  const submitBtn = document.getElementById('contactSubmit') as HTMLButtonElement | null

  if (!form || !feedback || !submitBtn) return
  if (typeof fabiosouzaAjax === 'undefined') return

  const btnText = submitBtn.querySelector<HTMLElement>('.btn-text')
  const btnLoading = submitBtn.querySelector<HTMLElement>('.btn-loading')

  // Phone mask
  const phoneInput = document.getElementById('contact-telefone') as HTMLInputElement | null
  phoneInput?.addEventListener('input', () => {
    let v = phoneInput.value.replace(/\D/g, '').slice(0, 11)
    if (v.length > 6) {
      v = v.length === 11
        ? `(${v.slice(0, 2)}) ${v.slice(2, 7)}-${v.slice(7)}`
        : `(${v.slice(0, 2)}) ${v.slice(2, 6)}-${v.slice(6)}`
    } else if (v.length > 2) {
      v = `(${v.slice(0, 2)}) ${v.slice(2)}`
    } else if (v.length > 0) {
      v = `(${v}`
    }
    phoneInput.value = v
  })

  form.addEventListener('submit', async (e) => {
    e.preventDefault()

    submitBtn.disabled = true
    if (btnText) btnText.hidden = true
    if (btnLoading) btnLoading.hidden = false
    feedback.className = 'form-feedback'
    feedback.style.display = 'none'

    const data = new FormData(form)
    data.append('action', 'fabiosouza_contact')
    data.append('nonce', fabiosouzaAjax!.nonce)

    try {
      const res = await fetch(fabiosouzaAjax!.ajaxurl, { method: 'POST', body: data })
      const json = await res.json() as { success: boolean; data?: { message?: string } }

      feedback.textContent = json.data?.message ?? (json.success ? 'Enviado!' : 'Erro ao enviar.')
      feedback.className = `form-feedback ${json.success ? 'success' : 'error'}`
      feedback.style.display = 'block'

      if (json.success) {
        form.reset()
        if (typeof turnstile !== 'undefined') turnstile.reset()
      }
    } catch {
      feedback.textContent = 'Erro de conexão. Tente novamente.'
      feedback.className = 'form-feedback error'
      feedback.style.display = 'block'
    } finally {
      submitBtn.disabled = false
      if (btnText) btnText.hidden = false
      if (btnLoading) btnLoading.hidden = true
    }
  })
})
